module.exports = import("https://unpkg.com/supersimpledev@8.5.0/dayjs/esm/index.js");;